var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-form" }, [
    _vm.hasError
      ? _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fas fa-exclamation-triangle" }),
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.successMessage
      ? _c(
          "div",
          { staticClass: "alert alert-success", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fas fa-check-circle" }),
            _vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "auth-form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.handleLogin.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.credentials.email,
                expression: "credentials.email",
              },
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.errors.email },
            attrs: {
              id: "email",
              type: "email",
              placeholder: "Enter your email",
              required: "",
              "data-test": "email",
              disabled: _vm.isLoading,
            },
            domProps: { value: _vm.credentials.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.credentials, "email", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm.errors.email
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v("\n        " + _vm._s(_vm.errors.email[0]) + "\n      "),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "password-input-wrapper" }, [
            (_vm.showPassword ? "text" : "password") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.credentials.password,
                      expression: "credentials.password",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.password },
                  attrs: {
                    id: "password",
                    placeholder: "Enter your password",
                    required: "",
                    "data-test": "password",
                    disabled: _vm.isLoading,
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.credentials.password)
                      ? _vm._i(_vm.credentials.password, null) > -1
                      : _vm.credentials.password,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.credentials.password,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.credentials,
                              "password",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.credentials,
                              "password",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.credentials, "password", $$c)
                      }
                    },
                  },
                })
              : (_vm.showPassword ? "text" : "password") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.credentials.password,
                      expression: "credentials.password",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.password },
                  attrs: {
                    id: "password",
                    placeholder: "Enter your password",
                    required: "",
                    "data-test": "password",
                    disabled: _vm.isLoading,
                    type: "radio",
                  },
                  domProps: { checked: _vm._q(_vm.credentials.password, null) },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.credentials, "password", null)
                    },
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.credentials.password,
                      expression: "credentials.password",
                    },
                  ],
                  staticClass: "form-control",
                  class: { "is-invalid": _vm.errors.password },
                  attrs: {
                    id: "password",
                    placeholder: "Enter your password",
                    required: "",
                    "data-test": "password",
                    disabled: _vm.isLoading,
                    type: _vm.showPassword ? "text" : "password",
                  },
                  domProps: { value: _vm.credentials.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.credentials, "password", $event.target.value)
                    },
                  },
                }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "password-toggle",
                attrs: { type: "button", disabled: _vm.isLoading },
                on: {
                  click: function ($event) {
                    _vm.showPassword = !_vm.showPassword
                  },
                },
              },
              [
                _c("i", {
                  class: _vm.showPassword ? "fi fi-eye-slash" : "fi fi-eye",
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.errors.password
            ? _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.errors.password[0]) + "\n      "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-options" },
          [
            _c("label", { staticClass: "checkbox-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rememberMe,
                    expression: "rememberMe",
                  },
                ],
                staticClass: "form-checkbox",
                attrs: { type: "checkbox", disabled: _vm.isLoading },
                domProps: {
                  checked: Array.isArray(_vm.rememberMe)
                    ? _vm._i(_vm.rememberMe, null) > -1
                    : _vm.rememberMe,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.rememberMe,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.rememberMe = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.rememberMe = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v("\n        Remember me\n      "),
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "forgot-link",
                attrs: { to: `/${_vm.currentLocale}/auth/forgot-password` },
              },
              [_vm._v("\n        Forgot Password?\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-block",
            attrs: {
              type: "submit",
              disabled: _vm.isLoading,
              "data-test": "login-button",
            },
          },
          [
            _vm.isLoading
              ? _c("span", { staticClass: "loading-spinner" })
              : _vm._e(),
            _vm._v(
              "\n      " +
                _vm._s(_vm.isLoading ? "Signing In..." : "Sign In") +
                "\n    "
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "p",
        { staticClass: "signup-link" },
        [
          _vm._v("\n      Don't have an account?\n      "),
          _c(
            "router-link",
            {
              staticClass: "link-primary",
              attrs: { to: `/${_vm.currentLocale}/auth/register` },
            },
            [_vm._v("\n        Sign up here\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }